import { Component, Injector, OnInit } from '@angular/core';
import { UserModel } from '../../authentication/models/user.model';

@Component({
    selector: 'chassis-home-page',
    templateUrl: './home.page.html',
    styleUrls: ['./home.page.scss']
})
export class HomeComponent implements OnInit {

    public myUser = new UserModel();

    public mask;

    public comment;

    public form;

    public constructor(protected injector: Injector) {
    }

    ngOnInit(): void {
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/pages/home/home.page.ts